import { createReducer, on } from '@ngrx/store';

import { setGloballyAvailableTags } from './tag.actions';
import { TagSliceState } from './tag.state';

export const tagReducer = createReducer<TagSliceState>(
	new TagSliceState(),
	on(setGloballyAvailableTags, (state, action) =>
		state.setTags(action.availableTags)
	)
);
